/**
 * WHO OUR EMAIL COMES FROM.
 *
 * One line, in one place, because it is shown to people. The screen that says
 * "check your spam for a message from …" is the only thing somebody reads when
 * the email has not arrived, and an address that is out of date there sends
 * them looking for something that was never sent.
 *
 * It was previously derived from the Firebase config — `noreply@` plus whatever
 * authDomain happened to be — which was true until the sender changed and then
 * silently was not. Nothing failed; the screen simply told people to look for
 * the wrong sender.
 *
 * scripts/test-sender-address.mjs checks this against the address Supabase is
 * actually sending from, so the two cannot drift again.
 *
 * AND IT CAUGHT IT, 14 August. Setting up mail on both projects moved the sender
 * from `hello@` to `support@`, and this line still named the old one — so the
 * screen would have told everybody to look for a message from an address that
 * sends nothing. Exactly the failure described above, caught by the check rather
 * than by somebody who never got their sign-in link.
 *
 * IT WILL CHANGE ONCE MORE. Only `mail.flightdeck.build` is verified in Resend
 * today; the root domain is not, and mail from an unverified domain is accepted
 * and then silently binned. When the root is verified and the sender becomes
 * `support@flightdeck.build`, this line moves with it — and that test is what
 * will say so.
 */
export const SENDER = 'support@mail.flightdeck.build';
